import { Button, Col, Row, Spinner, Table } from "react-bootstrap";
import { useState } from 'react';
import { useTranslation } from "react-i18next";
import 'bootstrap-icons/font/bootstrap-icons.css';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import AppTablePagination from "../../../components/AppTable/AppTablePagination";
import { formatDateString, formatTimestampToDDMMYYYYHHMM } from "../../../utils/formatters/DateFormatter";
import { SurveyImportResultLinePagination } from "../types";
import { SurveyDetailDto } from "../../admin/surveys/types";
import { getSurvey } from "../../admin/surveys/api/surveyAPI";
import ModalGlobal from "../../../components/AppModal/ModalGlobal";
import { ApiErrorResponse } from "../../../types/ApiErrorResponse";
import {  getSurveyProccessAI } from "../api/surveyImportAPI";
import AlertMessage from "../../../components/AlertMessage";
import { useAlert } from "../../../hooks/useAlert";
import { useQueryClient } from "@tanstack/react-query";

interface SurveyImportDetailTableProps {
    surveyData: SurveyImportResultLinePagination;
    currentPage: number;
    itemsPerPage: number;
}

export default function SurveyImportDetailTable({ surveyData, currentPage, itemsPerPage }: SurveyImportDetailTableProps) {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [surveyDetail, setSurveyDetail] = useState<SurveyDetailDto | null>(null);
    const { alert, hideAlert, isVisible, showAlert } = useAlert({ fromLocation: true });

    const queryClient = useQueryClient();
    const handleOpen = () => setShowModal(true);
    const handleClose = () => setShowModal(false);




    const headerItemsModelArray = [t("survey:detail.modalShowDetailSurveyFieldExcel"), t("survey:detail.modalShowDetailSurveyFieldDestination"), t("survey:detail.modalShowDetailSurveyValue")];

    const SURVEY_TABLE_HEADERS = {
        id: t("survey:surveyImportDetail.headerTableSurvey1"),
        nameSurvey: t("survey:surveyImportDetail.headerTableSurvey2"),
        answerDate: t("survey:surveyImportDetail.headerTableSurveyAnswerDate"),
        state: t("survey:surveyImportDetail.headerTableSurvey3"),
        error: t("survey:surveyImportDetail.headerTableSurvey4"),
        actions: t("common:actions")

    };

    const getStateDescription = (state: number) => {
        if (state === 0) return t("survey:surveyImportDetail.surveyLoadStateIAPendient");
        if (state === 1) return t("survey:surveyImportDetail.surveyLoadStateIAProcessed");
        if (state === 2) return t("survey:surveyImportDetail.surveyLoadStateLoaded");
        if (state === 3) return t("survey:surveyImportDetail.surveyLoadStateCancel");
        if (state === 4) return t("survey:surveyImportDetail.surveyLoadStateError");
    }

    const handleSurveyDetail = async (idSurvey: number) => { 
        const surveyDetail = await getSurvey(idSurvey);
        setSurveyDetail(surveyDetail);
    }

    const handleProcessAI = async (surveyImportResultId: number) => {
        try {
            setLoading(true);

            await getSurveyProccessAI(surveyImportResultId);
            showAlert({
                message: t("survey:surveyImportDetail.messageSurveyProcessByIA"),
                type: "success",
                duration: 8000
            })
            queryClient.invalidateQueries({
                queryKey: ['getSurveyImportDetails'],
                exact: false,
                refetchType: 'all',
            });
            setLoading(false);


        } catch (error) {
            setLoading(false);
            const fetchError = error as ApiErrorResponse;
            showAlert({
                message: fetchError.message ?? t("common:requestError.errorBadRequest"),
                type: "danger",
                duration: 8000
            })
        }
    }


    const handleExportCsv = () => {
       
    }

    return (
        <div>
            {loading && (
                <div className="overlay-spinner">
                    <Spinner animation="border" variant="light" />
                </div>
            )}
            <Row>
                <Col className="text-center" xs={12} md={12}>
                    {isVisible && (
                        <AlertMessage
                            message={alert!.message}
                            type={alert!.type}
                            onClose={hideAlert}
                        />
                    )}
                </Col>
            </Row>
            
            <ModalGlobal
                show={showModal}
                onClose={handleClose}
                saveText={ ""}
                title={t("survey:detail.modalShowDetailSurveyTitle")}
                subtitle=""
                className="modal-gran"
                body={<div>
                    {surveyDetail && (
                        <>
                            <Table responsive className="mt-3">
                                <thead>
                                    <tr>
                                        {headerItemsModelArray.map((headerItem, index) => {
                                            return (
                                                <th key={index} className="" style={{ borderTop: "none", borderBottom: "1px solid black" }}>
                                                    {headerItem}
                                                </th>
                                            );
                                        })}
                                    </tr>

                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{ verticalAlign: "middle" }}>
                                            <div>
                                                {t("survey:detail.modalShowDetailSurveyIdSurvey")}
                                            </div>
                                        </td>
                                        <td style={{ verticalAlign: "middle" }}>
                                            <div>

                                            </div>
                                        </td>
                                        <td style={{ verticalAlign: "middle" }}>
                                            <div>
                                                {surveyDetail.id}
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ verticalAlign: "middle" }}>
                                            <div>
                                                {t("survey:detail.modalShowDetailSurveyNps")}
                                            </div>
                                        </td>
                                        <td style={{ verticalAlign: "middle" }}>
                                            <div>

                                            </div>
                                        </td>
                                        <td style={{ verticalAlign: "middle" }}>
                                            <div>
                                                {surveyDetail.nps}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ verticalAlign: "middle" }}>
                                            <div>
                                                {t("survey:detail.modalShowDetailSurveyCreateDate")}
                                            </div>
                                        </td>
                                        <td style={{ verticalAlign: "middle" }}>
                                            <div>

                                            </div>
                                        </td>
                                        <td style={{ verticalAlign: "middle" }}>
                                            <div>
                                               {formatDateString(surveyDetail.createDate)}
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ verticalAlign: "middle" }}>
                                            <div>
                                                {t("survey:detail.modalShowDetailSurveyAnswerDate")}
                                            </div>
                                        </td>
                                        <td style={{ verticalAlign: "middle" }}>
                                            <div>

                                            </div>
                                        </td>
                                        <td style={{ verticalAlign: "middle" }}>
                                            <div>
                                                {formatDateString(surveyDetail.answerDate)}
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ verticalAlign: "middle" }}>
                                            <div>
                                                {t("survey:detail.modalShowDetailSurveyComment")}
                                            </div>
                                        </td>
                                        <td style={{ verticalAlign: "middle" }}>
                                            <div>

                                            </div>
                                        </td>
                                        <td style={{ verticalAlign: "middle" }}>
                                            <div>
                                                {surveyDetail.comment}
                                            </div>
                                        </td>
                                    </tr>

                                    {surveyDetail.sentimentAI &&
                                        <tr>
                                            <td style={{ verticalAlign: "middle" }}>
                                                <div>
                                                    {t("survey:detail.modalShowDetailSurveyAISentiment")}
                                                </div>
                                            </td>
                                            <td style={{ verticalAlign: "middle" }}>
                                                <div>

                                                </div>
                                            </td>
                                            <td style={{ verticalAlign: "middle" }}>
                                                <div>
                                                    {surveyDetail.sentimentAI}
                                                </div>
                                            </td>
                                        </tr>}

                                    {surveyDetail.alertAI &&
                                        <tr>
                                            <td style={{ verticalAlign: "middle" }}>
                                                <div>
                                                    {t("survey:detail.modalShowDetailSurveyAIAlert")}
                                                </div>
                                            </td>
                                            <td style={{ verticalAlign: "middle" }}>
                                                <div>

                                                </div>
                                            </td>
                                            <td style={{ verticalAlign: "middle" }}>
                                                <div>
                                                    {surveyDetail.alertAI}
                                                </div>
                                            </td>
                                        </tr>}
                                    {surveyDetail.messageAI &&
                                        <tr>
                                            <td style={{ verticalAlign: "middle" }}>
                                                <div>
                                                    {t("survey:detail.modalShowDetailSurveyIAMitssage")}
                                                </div>
                                            </td>
                                            <td style={{ verticalAlign: "middle" }}>
                                                <div>

                                                </div>
                                            </td>
                                            <td style={{ verticalAlign: "middle" }}>
                                                <div>
                                                    {surveyDetail.messageAI}
                                                </div>
                                            </td>
                                        </tr>}
                                    {surveyDetail.recommendationAI &&
                                        <tr>
                                            <td style={{ verticalAlign: "middle" }}>
                                                <div>
                                                    {t("survey:detail.modalShowDetailSurveyIARecomendation")}
                                                </div>
                                            </td>
                                            <td style={{ verticalAlign: "middle" }}>
                                                <div>

                                                </div>
                                            </td>
                                            <td style={{ verticalAlign: "middle" }}>
                                                <div>
                                                    {surveyDetail.recommendationAI}
                                                </div>
                                            </td>
                                        </tr>}
                                    {surveyDetail?.topics?.length > 0 &&
                                        <tr>
                                            <td style={{ verticalAlign: "middle" }}>
                                                <div>
                                                    {t("survey:detail.modalShowDetailSurveyTopics")}
                                                </div>
                                            </td>
                                            <td style={{ verticalAlign: "middle" }}>
                                                <div>

                                                </div>
                                            </td>
                                            <td style={{ verticalAlign: "middle" }}>
                                                <div>
                                                   {surveyDetail.topics?.map(t => t.topicName).join(", ") || "-"}

                                                </div>
                                            </td>
                                        </tr>}
                                    {surveyDetail?.subTopics?.length > 0 &&
                                        <tr>
                                            <td style={{ verticalAlign: "middle" }}>
                                                <div>
                                                    {t("survey:detail.modalShowDetailSurveySubTopics")}
                                                </div>
                                            </td>
                                            <td style={{ verticalAlign: "middle" }}>
                                                <div>

                                                </div>
                                            </td>
                                            <td style={{ verticalAlign: "middle" }}>
                                                <div>
                                                    {surveyDetail.subTopics}
                                                </div>
                                            </td>
                                        </tr>}
                                    {surveyDetail?.extraFields.map((extraField) => {
                                        return (
                                            <tr>
                                                <td>
                                                    <div>
                                                        {extraField.fieldExcel}{' '}
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={<Tooltip id="tooltip-info">
                                                                {extraField.description}
                                                            </Tooltip>}
                                                        >
                                                            <span style={{ cursor: 'pointer' }}>
                                                                <i className="bi bi-info-circle text-primary"></i>
                                                            </span>
                                                        </OverlayTrigger>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        {extraField.field}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        {extraField.type === "Date" ? formatDateString(extraField.value) : extraField.value}
                                                    </div>
                                                </td>


                                            </tr>
                                        );
                                    })}

                                </tbody>
                            </Table>
                        </>
                    )}
                </div>}
                closeText={t("common:buttons.buttonClose")} isLoading={false} />
          

                <Table responsive className="mt-3 ">
                    <thead>
                        <tr>
                            {Object.values(SURVEY_TABLE_HEADERS).map((header, index) => (
                                <th key={Object.keys(SURVEY_TABLE_HEADERS)[index]} className="text-center" style={{ borderTop: "none", borderBottom: "1px solid black" }}>
                                    {header}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    {surveyData && surveyData.items.length > 0 ? (
                        <tbody style={{ textAlign: "center" }}>
                            {surveyData.items.map((data, index) => (
                                <tr key={index}>
                                    <td style={{ verticalAlign: "middle" }}>
                                        <div>
                                            {data.surveyImportResultId}
                                        </div>
                                    </td>
                                    <td style={{ verticalAlign: "middle" }}>
                                        <div>
                                            {data.row}
                                        </div>
                                    </td>
                                    <td style={{ verticalAlign: "middle" }}>
                                        <div>
                                            {formatTimestampToDDMMYYYYHHMM(data.answerDate)}
                                        </div>
                                    </td>
                                    <td style={{ verticalAlign: "middle" }}>
                                        <div>
                                            {getStateDescription(data.state)}
                                        </div>
                                    </td>
                                    <td style={{ verticalAlign: "middle" }}>
                                        <div>
                                            {data.error ?? '-'}
                                        </div>
                                    </td>
                                    <td style={{ verticalAlign: "middle" }}>
                                        <Button onClick={() => {
                                            handleSurveyDetail(data.surveyImportResultId);
                                            handleOpen();
                                        }} className="btn btn-sm btn-gris2" style={{ marginRight: 8, }}>
                                            <i className="bi bi-file-text" title={t("common:buttons.buttonSeeDetail")}></i>
                                        </Button>
                                        {data.state === 2 || data.state === 4 ? (
                                            <Button className="btn btn-sm btn-gris2" onClick={() => handleProcessAI(data.surveyImportResultId)}>
                                                < img src="/paper-plane-top-thin-full.svg" title={t("surveyAdmin:buttonProcessAISurveyLoad")} style={{ width: 16, height: 16 }} />
                                            </Button>
                                        ) : null}

                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    ) : (
                        <tbody>
                            <tr>
                                <td colSpan={Object.values(SURVEY_TABLE_HEADERS).length}>{t("survey:surveyImportDetail.nonSureveyImportDetails")}</td>
                            </tr>
                        </tbody>
                    )}
                    <tfoot>
                        <AppTablePagination
                            currentPage={currentPage}
                            totalPages={surveyData.totalPages}
                            pageSize={itemsPerPage}
                            totalRecords={surveyData.totalRecords}
                            showExportLink={true}
                            onExportCsv={handleExportCsv}
                            selectorType="detailSurveyLoads"
                        />
                    </tfoot>
                </Table>
            
        </div>
)}
